import styled from 'styled-components';

export const GoSafePersuation = styled.div`
  border-radius: 0.4rem;
  border: solid 1px rgba(23, 163, 98, 0.2);
  background-color: #e9f6ea;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  width: 100%;
  
`;
export const Info = styled.span`
  font-size: 1.6rem;
  padding-left: 1.5rem;
  color: #00913a;
`;
export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
